export const authEndpoints = {
  login: 'setup/api/Account/authenticate',
};

export const customerEndpoints = {
  create: 'setup/api/Customer',
};

export const serviceLevelEndPoints = {
  serviceLevel: 'setup/api/ServiceLevel',
  serviceLevelSearch: 'setup/api/ServiceLevel',
  ServiceLevelStatus: 'setup/api/ServiceLevel/status',
  //Earlier GET API used to fetch Service Level replaced with this new POST API to support filters
  serviceLevelSearchUpdated: 'setup/api/ServiceLevel/Search',
};

export const commonEndPoints = {
  serviceLevelType: 'setup/api/Common/GetServiceLevelType',
  serviceLocation: 'setup/api/Common/GetServiceLocation',
  contactServiceOfferingAddOn:
    'setup/api/Common/GetContactServiceOfferingAddOn',
  shipMethod: 'setup/api/Common/GetShipMethod',
  servicePriceLevel: 'setup/api/Common/GetServicePriceLevel',
  workOrderType: 'setup/api/Common/GetWorkOrderType',
  serviceResponseType: 'setup/api/Common/GetServiceResponseType',
  countrySearch: 'setup/api/Common/Countries/search',
  countries: 'setup/api/Common/GetCountries',
  serviceType: 'setup/api/Common/GetServiceType',
  currencies: 'setup/api/Common/GetCurrency',
  orderTypes: 'setup/api/Common/ERPSalesOrder/OrderGroup?isStaging=true',
  noteType: 'setup/api/Common/Customer/NoteType',
  oosCasesReviewStatus: 'setup/api/Common/OOSCases/Status',
  caseType: 'setup/api/Common/OOSCases/CaseType',
  chargeCode: 'setup/api/Common/OOSItems/ChargeCode',
  userPermissions: 'users/api/User',
  userLoginActivity: 'users/api/User/Login/Activity',
  internalUserPermissions: 'users/api/User/LoginWithToken',
  getContractHistoryTypes: 'entitlements/api/Entitlement/ContractHistoryTypes',
};

export const erpProductEndPoints = {
  searchProduct: 'setup/api/Product/Search',
  productType: 'setup/api/ProductType',
  hardwareClass: 'setup/api/HardwareClass',
  generalInfoTab: 'setup/api/Product/General',
  productFamilyBillClass: 'setup/api/PriceBook/GetBillClass',
  salesInfo: 'setup/api/Product/Sales/Contracts',
  serviceModal: 'setup/api/SubmodelProduct/SearchName',
  saveGeneralInfo: 'setup/api/Product/General',
  serviceInfoModel: 'setup/api/ServiceProduct/Models',
  serviceInfoSubModel: 'setup/api/ServiceProduct/SubModels',
  subModelSearch: 'setup/api/SubmodelProduct/SubModelsByName',
  sericeFee: 'setup/api/ServiceProduct/ServiceFee',
  seviceFeeGridData: 'contracts/api/OutOfScope/HardwareFeesWithContractDetails',
  searchContracts:
    'contracts/api/ServiceProductContractOverride/SearchContracts',
  ServiceProductDetails: '/setup/api/ServiceProduct/ServiceProductDetails',
  endOfServiceGridData: 'contracts/api/ServiceProductContractOverride',
  generalInfoSave: 'setup/api/Product/General',
  saveSubModelsNSubModels: 'setup/api/ServiceProduct/SaveModelsNSubModels',
  saveServiceInfoFee: 'setup/api/ServiceProduct/ServiceFee',
  saveEndOfService: 'contracts/api/ServiceProductContractOverride',
  eosModelAcceptButton: 'contracts/api/ServiceProductContractOverride',
  eosJob: 'setup/api/Product/TaskProductEos',
};

export const priceBookEndPoint = {
  accountingGroup: 'setup/api/AccountingGroup',
  priceTypes: 'setup/api/PricingType',
  priceSheetSearch: 'setup/api/PriceSheet/Search',
  accountingGroupSearch: 'setup/api/AccountingGroup/Search',
  priceSheetGet: 'setup/api/PriceSheet/GetById',
  pricesGet: 'setup/api/PriceSheet/PricingClass/GetByPriceSheet',
  priceSheetNotes: 'setup/api/PriceSheet/PricingNote/GetByPriceSheet',
  priceSheetAuditTrail: 'setup/api/PriceSheet/PricingNote/GetByPriceSheet',
  priceClassServiceOfferings: 'setup/api/PriceSheet/PriceClassService/Search',
  priceSheetSave: 'setup/api/PriceSheet/Save',
  priceSheetSearchCount: 'setup/api/PriceSheet/Search',
  copypriceSheetSave: 'setup/api/PriceSheet/Copy',

  priceClassGet: 'setup/api/PriceBook/GetPriceClass',
  priceClassSearch: 'setup/api/PriceBook/Search/PriceClass',

  billClass: 'setup/api/PriceBook/GetBillClass',
  billClassSearch: 'setup/api/PriceBook/Search/BillClass',
  removeBillClass: 'setup/api/PriceBook',
  addBillClass: 'setup/api/PriceBook/AddBillClass',
};

//EntitleMent -> Contracts
export const contractsEndPoints = {
  contractsSearchById: 'contracts/api/Contracts/Search',
  accountingGroup: 'setup/api/AccountingGroup/Search',
  customer: 'customers/api/Customer/search',
  billTo: 'setup/api/Site/Search',
  site: 'setup/api/Site/Search',
  siteSearch: 'setup/api/Site',
  status: 'contracts/api/Common/Contract/Status',
  level: 'contracts/api/Common/Contract/Level',
  contractsSearch: 'contracts/api/Contracts/Search',
  approvals: 'contracts/api/Contracts/ApprovalQueue',
  billToAndSiteSearch: 'setup/api/Site',
  siteType: 'setup/api/SiteType',
  createNewContract: 'contracts/api/Contracts',
  returnToCreate: 'contracts/api/Contracts/ReturnToCreate',
  trickleDownContractChange: 'contracts/api/Contracts/ContractChange',
  notesTab: {
    getNote: 'contracts/api/ContractNote',
    postNote: 'contracts/api/ContractNote',
  },
  salesMapping: {
    productNameCodeSearch: 'setup/api/Product/ServiceProduct/Search',
    serviceLevelName: 'setup/api/Common/Contract/ServiceLevel',
    deleteOrderable: 'contracts/api/Contract/SalesMapping/Orderable',
    saveOrderable: 'contracts/api/Contract/SalesMapping/Orderable',
    fetchOrderableData: 'contracts/api/Contract/SalesMapping/Orderable',
    fetchSupportedZone: 'contracts/api/Contracts/SalesMapping/SupportedZone',
    fetchSupported: 'contracts/api/Contracts/SalesMapping/Supported',
    deleteSupported:
      'contracts/api/Contracts/SalesMapping/RemoveSupportedSalesProduct',
    createNewContract: 'contracts/api/Contracts',
    unsupported: 'contracts/api/Contracts/SalesMapping/Unsupported',
    searchSalesOrderReport: 'contracts/api/Contracts/SalesMapping/SalesOrder',
    searchHigherSalesOrderReport:
      'contracts/api/Contracts/SalesMapping/HigherContractSalesOrder',
    searchSalesOrder: 'contracts/api/SalesMapping/GetAssociateSalesProduct',
    addUnsupportedSalesProduct:
      'contracts/api/SalesMapping/InsertUnsupportedSalesProduct',
    deleteUnsupported:
      'contracts/api/SalesMapping/DeleteUnsupportedSalesProduct',
    deleteHigherSalesOrderReport:
      'contracts/api/Contracts/SalesMapping/IgnoreSalesOrder',
  },
  warrantyExtendedPeriod: {
    fetchServiceOfferingData:
      'contracts/api/Contracts/Warranty/ServiceOfferings/Search',
    deferralPriceClassSearch: 'setup/api/PriceSheet/SearchByPriceClassId',
    deferralPriceClassSearchByCountry: 'setup/api/PriceSheet/SearchByCountry',
    extendedWarrantySave: 'contracts/api/Contracts/Warranty',
    fetchContractPriceClasses: 'contracts/api/Contracts/PriceClass/Search',
    fetchContractPriceClassOptions:
      'contracts/api/Contracts/PriceClass/PriceOptionsWithServices', // 'contracts/api/Contracts/PriceClass/PriceOptions'
    fetchContractServiceOfferings:
      'contracts/api/Contracts/PriceClass/Services',
    fetchDeferralServiceOffering: 'contracts/api/Contracts/Deferral',
    getCpiValues: 'billing/api/CpiSetup',
    selectedOptionDefferalServiceOffering:
      'contracts/api/Contracts/PriceClass/PriceClassOptions/DeferralServiceOfferings',
  },
  selectedOptionsTab: {
    updateSelectedOptionsData: '/contracts/api/Contracts',
    getContractBillSets: 'contracts/api/Common/Contract/BillSets',
    getEmBillCycle: 'contracts/api/Common/Contract/EMBillCycle',
    getDefaultPricingOptions: 'customers/api/Site/ContractPricingOptions',
    getPriceClass: 'contracts/api/Contracts/PriceClass',
    updatePriceClassOptionsTab: 'contracts/api/Contracts/PriceClass',
  },
  contractHistoryTab: {
    getContractHistory: 'contracts/api/Contracts/History/Status',
    getContractHistoryCPI: 'contracts/api/Contracts/History/CPI',
    contractHistoryBackup: 'contracts/api/Contracts/History/Backup',
    returnTocreateModify: 'contracts/api/Contracts/ReturnToCreate',
    updateContractPriceclasses: 'contracts/api/Contracts/PriceClass',
  },
  contractOOSArchiveTab: {
    getCountries: 'contracts/api/OutOfScope/Countries',
    getHardwareFees: 'contracts/api/OutOfScope/HardwareFees',
    getHardwareLogistic: 'contracts/api/OutOfScope/HardwareLogistic',
    getHardwareLogisticAddOn: 'contracts/api/OutOfScope/HardwareLogisticAddOn',
    getLaborFees: 'contracts/api/OutOfScope/LaborFees',
  },
  contractsOOSTab: {
    updateContractOosHwLogisticAddOnNsFees:
      'contracts/api/OutOfScope/UpdateContractOosHwLogisticAddOnNsFeesAsync',
    updateLogisticsNonStdConsumableFee:
      'contracts/api/OutOfScope/UpdateLogisticsNonStdConsumableFee',
    updatePriceClassHwFeesNsFee:
      'contracts/api/OutOfScope/UpdatePriceClassHwLogisticNsFee',
    updateServiceOfferingHwLogisticNsFee:
      'contracts/api/OutOfScope/UpdatePriceClassHwLogisticNsFee',
  },
  createsubmitApproval: 'contracts/api/Contracts/Submit',

  copyContract: {
    CountContractPriceAndServicesMap:
      'contracts/api/Contracts/CountContractPriceAndServicesMap',
    copyContract: 'contracts/api/Contracts/CopyContract',
    searchContract: 'contracts/api/Contracts/Search',
    contractDetailsById: 'contracts/api/Contracts/Search',
  },
  approvalContract: 'contracts/api/Contracts/Approve',
  trickleContract: 'contracts/api/ContractTrickleDown/TrickleDown',
  saveContractDescription: 'contracts/api/Contracts/UpdateContractDescription',
  relatedContracts: 'contracts/api/Contracts/RelatedContracts',
};

export const warrantyEndPoints = {
  warrantySearch: 'setup/api/Warranties/Search',
  warrantyDetail: 'setup/api/Warranties/Detail',
  serialNoHistory: 'setup/api/Warranties/SerialNoHistory',
  entitlement: 'setup/api/Warranties/Entitlement',
};

export const eTrackSettingEndPoints = {
  entitelment: 'setup/api/EntitlementSetup',
  salesImport: 'setup/api/SalesImport',
  accountiGroup: 'setup/api/AccountingGroup',
};

export const oosBillSetsEndPoints = {
  fetchOosBillSets: 'setup/api/OosBillSet',
  fetchOosBillSetsById: 'setup/api/OosBillSet/BillRule',
  addBillSets: 'setup/api/OosBillSet',
  deleteBillSet: 'setup/api/OosBillSet',
  updateBillSets: 'setup/api/OosBillSet',
};

export const customersEndPoints = {
  accountingGroup: 'setup/api/AccountingGroup/Search',
  customersByGlobalCustomersNo: 'customers/api/Customer',
  customersByMultipleInputs: 'customers/api/Customer/Search',
  customersDetailsById: 'customers/api/Customer/Details',
  customersAddressDetailsById: 'customers/api/Customer/AddressDetails',
  customerHisotry: 'customers/api/Customer/History',
  customerChildren: 'customers/api/Customer/Children',
  customerNotes: 'customers/api/Customer/Notes',
  orderNumberSmartSearch: 'customers/api/SalesOrder/OrderNumbers',
  siteIDSmartSearch: 'customers/api/SalesOrder/SiteIDs',
  salesOrderCustomerSearch: 'customers/api/SalesOrder/Search',
  customerEntitlementSummary: 'customers/api/Customer/EntitlementSummary',
  customerSites: 'customers/api/Site',
  customerBillNotes: 'customers/api/Customer/BillingNotes',
  customerBillingBills: 'customers/api/Customer/Bills',
  updateCustomersInfo: 'customers/api/Customer',
  viewBill: 'billing/api/Billing/View',
  sendCustomerEntitlementSummaryEmail: 'customers/api/Customer/sendEmailWithFile',
};

export const erpSalesOrder = {
  orderStaging: 'entitlements/api/ErpSalesOrderStaging',
  orderNoItems: 'entitlements/api/ErpSalesOrderItem/Search',
  orderNo: 'entitlements/api/ErpSalesOrder/Search',
  createPurchaseOrder: 'entitlements/api/ErpSalesOrder/ManualPurchaseOrder',
  updatePurchaseOrder: 'entitlements/api/ErpSalesOrder/ManualPurchaseOrder',
  getPurchaseOrderNo: 'entitlements/api/ErpSalesOrder/ManualPurchaseOrderNo',
  accountingGroupErpSalesOrder: 'setup/api/AccountingGroup/Search',
  masterCustomerNumber: 'customers/api/Customer/Search',
  importStatus: 'setup/api/Common/ERPSalesOrder/ImportStatus',
  mappingType: 'setup/api/Common/ERPSalesOrder/MappingType',
  orderGroup: 'setup/api/Common/ERPSalesOrder/OrderGroup',
  accountingGroup: 'setup/api/AccountingGroup/Search',
  ncrSiteId: 'setup/api/Site',
  siteType: 'setup/api/SiteType',
  entitlementSummary: 'entitlements/api/ErpSalesOrder/EntitlementSummary',
  itemTab: {
    getOrderItems: 'entitlements/api/ErpSalesOrderItem',
    saveOrderLineItems: 'entitlements/api/ErpSalesOrderItem',
    updateErpLineItems: 'entitlements/api/ErpSalesOrderItem',
    deleteErpLineItems: 'entitlements/api/ErpSalesOrderItem',
    getOrderLine: 'entitlements/api/ErpSalesOrderItem/OrderLine',
  },
  searchProduct: 'setup/api/Product/Search',
  searchSalesProduct: 'setup/api/Product/SalesProduct/Search',
};

export const sitesEndPoints = {
  siteSearch: 'setup/api/Site',
  entitlementSummary: 'customers/api/Site/EntitlementSummary/Search',
  entitlementStatus: 'entitlements/api/Entitlement/Status',
  siteActivity: 'customers/api/Site/Activity',
  siteSalesOrder: 'entitlements/api/Site/SalesOrder',
  siteHistory: 'customers/api/Site/History',
  siteDetails: 'customers/api/Site/Details',
  siteDetailswithCustomerBillInfo: 'customers/api/Site/CustomerBillingInfo',
  siteNotes: '/entitlements/api/Site/Notes',
  addSiteNotes: '/entitlements/api/Site/Notes',
  siteVantiveList: '/entitlements/api/Site/Vantive',
  pricingOptions: 'customers/api/Site/ContractPricingOptions',
  siteTypeOptions: 'setup/api/SiteType',
  accountingGroup: 'customers/api/Site/AccountingGroup',
  address: 'customers/api/Site/Address',
  contract: 'customers/api/Site/Contracts',
  siteUpdate: 'customers/api/Site/Update',
  //Entitlement Details Tab
  siteEntitlementDetails: 'customers/api/Site/EntitlementDetails/Search',
  siteEntitlementCount: 'customers/api/Site/EntitlementDetails/Search',
  siteJobUpdateEntitlements:
    'entitlements/api/Entitlement/JobUpdateEntitlements',
  siteEntitlementDetailsEntitlementStatus:
    'entitlements/api/Entitlement/Status',
    updateSiteEntitlementsContract:
    'entitlements/api/Entitlement/UpdateSiteEntitlementsContractHistory', 
  //Site Activity Details - User Lands on this page after clicking on Activity Date
  //Site Activity Details - User Lands on this page after clicking on Activity Date
  //in Site Activity tab under Entitlement Details Tab of Entitlements
  //Begin
  siteActivityDetails: 'entitlements/api/Site/SiteActivityDetails',
  entitlementsbySiteIdAndActivity:
    'entitlements/api/Site/SiteActivityEntitlements',
  // entitlementsbySiteIdAndActivity:
  //   'entitlements/api/Site/SiteActivityEntitlements',
  updateSiteActivityDetails: 'entitlements/api/Site/SiteActivity',

  serviceProductSearch: 'setup/api/Product/ServiceProduct/Search',
  updatedServiceProductSearchTempAdd:
    'setup/api/Product/TempAdd/ServiceProduct/Search',
  sevriceLevelData: 'entitlements/api/Entitlement/ServiceLevel',
  tempAddEntitlement: 'entitlements/api/Entitlement/TempAddEntitlement',
  //End
};

export const entitelmentHistory = {
  getEntitlementData: 'entitlements/api/Entitlement',
  getStatusOFEntitlement: 'entitlements/api/Entitlement/Site/Status',
  updateActiveInactive: 'entitlements/api/Entitlement/Site/ActivateDeactivate',
  getEntitlementHistory: 'entitlements/api/Entitlement/History',
  insertEntitlementNote: 'entitlements/api/Entitlement/Note',
  getEntitlementHistoryStatus: 'entitlements/api/Entitlement/Status',
  getEntitlementHistoryDetails: 'entitlements/api/Entitlement/HistoryDetails',
  insertEntitlementHistory: 'entitlements/api/Entitlement/SiteHistory',
  getEntitlementServiceLevel: 'entitlements/api/Entitlement/ServiceLevel',
  entitlementTransfer: 'entitlements/api/Entitlement/Site/Transfer',
  getEntitlementTransferData:
    'entitlements/api/Entitlement/Site/Transfer/Entitlements',

  entitlementWarrantyHistory: 'entitlements/api/Entitlement/Warranty/History',
  entitlementSerialNumberHistory:
    'entitlements/api/Entitlement/Warranty/SerialNumberHIstory',
  getEntitlementSpecificWarrantyHistoryDetails:
    'entitlements/api/Entitlement/Warranty/HistoryDetails',
  checkWarrantyHistoryUpsert:
    'entitlements/api/Entitlement/Warranty/CheckWarrantyUpsert',
  validateWarrantyHistoryStartDate:
    'entitlements/api/Entitlement/Warranty/ValidateStartDate',

  createNewEntitlementWarranty: 'entitlements/api/Entitlement/Warranty',

  createUpdateNewEntitlementHistory:
    'entitlements/api/Entitlement/SiteHistories',

  saveAndCloseEntitlementTransfer: 'entitlements/api/Site/AddSiteActivity',

  saveAndCloseEntitlementSite: 'entitlements/api/Entitlement/Site',
  saveAndCloseEntitlementSiteActivity:
    'entitlements/api/Entitlement/SiteActivity',
};

export const entitlementsEndPoints = {
  entitlementsSearch: 'entitlements/api/Entitlement/Search',
  entitlementsSearchById: 'entitlements/api/Entitlement',
  entitlementSiteHistory: 'entitlements/api/Entitlement/SiteHistory',
  //Entitlements Search Options
  customersByGlobalCustomersNo: 'customers/api/Customer',
  accountingGroup: 'setup/api/AccountingGroup/Search',
  entitlementsCustomerSearchByName: 'customers/api/Customer/Search',
  entitlementsCustomerSearch: 'customers/api/Customer/Search',
  entitlementsbyMultipleInputs: 'customers/api/Customer/Search',
  entitlementsSite: 'setup/api/Site',
  entitlementsStatus: 'entitlements/api/Entitlement/Status',
  entitlementsType: 'entitlements/api/Entitlement/EntitlementType',
  entitlementsServiceProducts: 'setup/api/Product/ServiceProduct/Search',
};

export const entitlementsNotesEndPoints = {
  getEntitlementNotesData: 'entitlements/api/Entitlement/Notes',
  createEntitlementNote: 'entitlements/api/Entitlement/Note',
};

export const entitlementsShippingInfoEndPoints = {
  getEntitlementsShippingInfo: 'entitlements/api/Entitlement/ShippingInfo',
};

export const entitlementProductHistoryEndPoints = {
  getEntitlementProductHistory: 'entitlements/api/Entitlement/ProductHistory',
};

export const outOfScopeCasesEndPoints = {
  accountingGroup: 'setup/api/AccountingGroup/Search',
  oosCasesByMultipleInputs: 'entitlements/api/OOSCases/Search',
  getSummary: 'entitlements/api/OOSCases/Summary',
  getCaseId: 'entitlements/api/OOSCases/CaseID',
  getNotes: 'entitlements/api/OOSCases/Notes',
  getCaseDetails: 'entitlements/api/OOSCase/Details',
  getCaseSiteDetails: 'entitlements/api/OOSCase/SiteDetails',
  getOOSCaseItems: 'entitlements/api/OOSCasesItems',
  getOOSCaseItemHistory: 'entitlements/api/OOSCasesItems/History',
  getOOSCaseItemComment: 'entitlements/api/OOSCasesItems/Comment',
  getOOSCaseItemRMA: 'entitlements/api/OOSCasesItems/RMA',
  saveOOSCaseItems: 'entitlements/api/OOSCasesItems/Save',
};

export const entitlementsSiteActivityEndPoints = {
  getEntitlementsSiteActivity: 'entitlements/api/Site/SiteActivity',
  getSiteActivityEntitlements: 'entitlements/api/Site/SiteActivityEntitlements',
  entitlementSiteActivityJob: 'entitlements/api/ProcessSiteActivity',
};

export const warrantyInforTab = {
  getSerialNoHistory: 'setup/api/Warranties/SerialNoHistory',
  rqsModal: 'entitlements/api/Entitlement/Warranties',
  wpnChange: 'entitlements/api/Entitlement/WarrantyPartNoChange',
  getSerialNoInfo: 'entitlements/api/Entitlement/GetSerialNoInfo',
  searchSrNoFilters: 'entitlements/api/Entitlement/SerialNoForSwap',
  swapEsr: 'entitlements/api/Entitlement/SwapEntitlementSerialNo',
  searchWarranties: 'entitlements/api/Entitlement/Warranties',
};

export const erpSalesOrderItemsEndPoints = {
  //=> Fetching Sales Order Items using Search Options
  fetchERPSalesOrderItems: 'entitlements/api/ErpSalesOrderItem/Search',
  //Search Options
  fetchImportStatus: 'setup/api/Common/ERPSalesOrder/ImportStatus',
  fetchMappingType: 'setup/api/Common/ERPSalesOrder/MappingType',
  fetchorderGroup: 'setup/api/Common/ERPSalesOrder/OrderGroup',
  fetchCustomerNameContains: 'customers/api/Customer/Search',
  updateErpSalesOrderItemsDisplayUnsupportedFlag:
    'entitlements/api/ErpSalesOrderItem',
  accountingGroup: 'setup/api/AccountingGroup/Search',
  SalesProducts: 'setup/api/Product/SalesProduct/Search',
  mcnaccountingGroup: 'setup/api/AccountingGroup/Search',
  customerSearch: 'customers/api/Customer/Search',
  customerSearchByName: 'customers/api/Customer/Search',
  orderGroups: 'setup/api/Common/ERPSalesOrder/OrderGroup?isStaging=true',
  erpSalesOrderItemEntitlements:
    'entitlements/api/ErpSalesOrderItem/Entitlements/Search',
  createEntitlement: 'entitlements/api/ErpSalesOrderItem/Entitlement',
  resetLine: 'entitlements/api/ErpSalesOrderItem/ResetLine',
  jobCreateEntitlements:
    'entitlements/api/ErpSalesOrderItem/CreateEntitlements',
};

export const oosBatchUpdate = {
  getStatus: 'setup/api/Common/OOSCases/Status',
  getCaseType: 'setup/api/Common/OOSCases/CaseType',
  getResolutionCode: 'setup/api/Common/OOSCases/ResolutionCode',
  fetchOosBatchData: 'entitlements/api/OosBatchs',
  updateOosBatchData: 'entitlements/api/OosBatchs',
};

export const entitlementContractHistoryEndpoint = {
  getEntitlementContractHistory: 'entitlements/api/Entitlement/ContractHistory',
  updateEntitlementContractHistory: 'entitlements/api/ErpSalesOrderItem/UpdateEntitlementContractHistory',
};

export const eTrackEndPoints = {
  searchQuote: 'quotes/api/ETrack/Search',
  serviceModal: 'quotes/api/ETrack/ServiceModel',
  siteType: 'setup/api/SiteType',
  //E-Track - Fetch Quote Types
  quoteTypes: 'quotes/api/Quote/QuoteType',
  //E-Track - Create Quote
  createQuote: 'quotes/api/Quote/CreateQuote',
  //E-Track - Create Quote - Adding Items not selected if Quote type is Upgrade/Move Warranties and SiteSync Flag is 'y'
  createQuoteAddItems: 'quotes/api/Quote/QuoteItemForSiteSync',
  //E-Track - Save Quote
  saveQuote: 'quotes/api/Quote/Save',
  //E-Track - Delete Quote
  deleteQuote: 'quotes/api/Quote/DeleteQuote',
  //E-Track - Submit Quote
  submitQuote: 'quotes/api/Quote/SubmitQuote',
  //E-Track - Get Quote Details
  getQuoteDetail: 'quotes/api/Quote/Detail',
  //E-Track - Get Quote Details For Email Body
  getQuoteDetailForEmail: 'quotes/api/Quote/Email',
  //E-Track - Complete Job
  getJobComplete: 'quotes/api/Quote/Process',
  getExportResellerQuote: 'entitlements/api/ETrack/ExportResellerQuote',
  getExportClientQuote: 'entitlements/api/ETrack/ExportClientQuote',
  //----- Update Quote Items --------------------------------
  //E-Track - Update Quote Items - Remove/Delete Quote Item/s
  deleteQuoteItems: 'quotes/api/Quote/DeleteQuoteItems',
  //E-Track - Add Items - Submit
  submitQuoteItems: 'quotes/api/Quote/Item',
  //E-Track - Add Items for Multiple Sites Site Sync
  addItemsForMultipleSites: 'quotes/api/Quote/Item',
  //E-Track - Update Quote Items - Site Search
  updateQuoteItemsSiteSearch: 'setup/api/Site/Etrack',
  //E-Track - Update Quote Items - Service Level
  updateQuoteItemsServiceLevel: 'quotes/api/Quote/GetServiceLevel',
  //E-Track - Update Quote Items - Warranty Should DropDown
  updateQuoteItemsWarrantyShould: 'quotes/api/Quote/GetWarrantyStatus',
  //E-Track - Update Quote Item
  updateQuoteItem: 'quotes/api/Quote/UpdateQuoteItem',
  //E-Track - Get Entitlement of Site
  getEntitlementsOfSite: 'quotes/api/Quote/site/Entitlements',
  //E-Track:External User - Get MCN List
  getExternalUserMCNList: 'users/api/User/ETrack/GetMcnList',
};

export const eTrack = {
  fetchExistingQuotes: 'quotes/api/Quote/Search',
  getQuoteDetail: 'quotes/api/Quote/Detail',
  getQuoteItems: 'quotes/api/Quote/ItemDetail',
  getQuoteHistory: 'quotes/api/Quote/HistoryDetail',
};

export const eTrackQuoteApproval = {
  fetchApprovalQuotes: 'quotes/api/Quote/ApprovalQueue/Search',
  getSubmissionQueue: 'setup/api/Common/Quote/Status',
  getSiteInfo: 'quotes/api/Quote/SiteInfo',
  getEntitlementSite: 'quotes/api/Quote/EntitlementSite',
  approveRejectQuote: 'quotes/api/Quote/ApproveRejectQuote',
};

export const billingEndpoints = {
  getHistory: 'billing/api/Billing/History',
  billingSearch: 'billing/api/Billing/Search',
  billingStatus: 'billing/api/Billing/StatusList',
  searchCpiByCountry: 'billing/api/CPISetup/SearchCPIByCountry',
  searchCpiSetupTab: 'billing/api/CPISetup/Search',
  approvBills: 'billing/api/BillingTool/ApproveBill',
  getCpiHistory: 'billing/api/CpiSetup/GetHistory',
  updateCpiAmount: 'billing/api/CpiSetup',
  removeCpi: 'billing/api/CpiSetup',
  reset: 'billing/api/CpiSetup/Reset',
  updateContractCpi: '/billing/api/CpiSetup/UpdateContracts',
  billingContractDetails: 'billing/api/BillingTool/BillingContractDetails',
  billingGridData: 'billing/api/BillingTool/BillingToolBillTabEmiliExport',
  billingDetailsTabData: 'billing/api/BillingTool/BillingToolBocExport',
  getBillingNotes: 'billing/api/Billing/Notes',
  getBillingLineDD: 'billing/api/Billing/BillLine',
  addBillingNoteLineHeader: 'billing/api/Billing/Notes',
  regenerateBill: 'billing/api/BillingTool/RegenerateBill',
  getCountry: 'billing/api/CpiSetup/Country',
  continue: 'billing/api/CpiSetup/UpdateCountry',
  putCpiSetupLockDown: 'billing/api/CpiSetup/LockDown',
  getCpiSetupLockDown: 'billing/api/CpiSetup/LockDown',
};

export const adminScreenRole = {
  getRoles: 'users/api/UserRoleAccessPermissions/Roles',
  getRolePermission: 'users/api/UserRoleAccessPermissions/RolePermissions',
  setRolePermission: 'users/api/UserRoleAccessPermissions/RolePermissions',
  loginWithToken: 'users/api/User/LoginWithToken',
};

export const eBillingActivityEndPoints = {
  getEntitlementsBillingActivityCPI:
    'entitlements/api/Entitlement/BillingActivity/CPI',
  getEntitlementBillingActivityBilling:
    'billing/api/BillingTool/BillingToolBocExport',
};

export const emailEndPoints = {
  sendEmail: 'quotes/api/Quote/SendEmail',
};

export const externalLoginEndPoints = {
  //Authorization End Points RSIM
  loginActivity: 'users/api/User/Login/Activity', //to track MCNID of customer
  token: 'users/api/Etrack', //to get the token
  getUserId: 'users/api/User', //to get the User Id
};

export const eTrackMCNMappingPoints = {
  getEtrackCustomers: 'users/api/User/ETrack/SearchMcn',
  getEtrackCustomerMCN: 'users/api/User/ETrack/GetMcnList',
  addEtrackUserMCN: 'users/api/User/ETrack/AddMcnMapping',
  deleteEtrackUserMCN: 'users/api/User/ETrack/DeleteMcnMapping',
};